import { useContext } from 'react'
import { ModalContext } from '../ModalContext'
import { Bars3BottomLeftIcon } from '@heroicons/react/24/outline'

export default function TextModal() {
    const { modalData } = useContext(ModalContext)

    return (
        <>
            <div className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-orange-400">
                <Bars3BottomLeftIcon className="h-8 w-8 text-white" aria-hidden="true" />
            </div>

            <div className="text-center text-lg font-semibold leading-6 text-gray-900">{modalData.titleText}</div>

            <div className="space-y-2">
                {modalData.bodyText.map((text, index) => (
                    <p key={index} className="text-sm text-gray-600">
                        {text}
                    </p>
                ))}
            </div>
        </>
    )
}
